import React, { useEffect, useState } from "react";
import Notification from "../../components/Notification";
import { inject } from "mobx-react";
import PageTitle from "../../components/PageTitle/PageTitle";
import HeaderFilters from "./HeaderFilters";
import Footer from "../../components/Footer/Footer";
import { filtersDefault, notificationDefault } from "./constants";
import GerenciadorOrcamentosTable from "./GerenciadorOrcamentosTable";
import { calcularValorTotalFindAllOrcamento, findAllOrcamentoOdontologicoProcedimento } from "../../services/GerenciadorOrcamentosService";
import { getStatusOrcamentoPendenteAprovacao } from "../../services/StatusOrcamentoService";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { Button } from "../../components/ui/Buttons";
import PrintIcon from "../../components/Icon/Print";
import DownaloadIcon from "../../components/Icon/DownloadIcon";
import {
  findAllOrcamentoList,
  relatorioAllOrcamentoCsv,
} from "../../services/OrcamentoService";
import { base64Convert } from "../../utils/base64ToCsv";
import ImpressaoHtml from "../../components/Impressao/ImpressaoHtml";
import { withStyles } from "@material-ui/core";
import GerenciadorOrcamentosRelatorio from "../../template/pdf/gerenciadorOrcamentos/GerenciadorOrcamentosRelatorio";
import ModalOrcamentoGerenciador from "./Modal/ModalOrcamentoGerenciador";
import ModalConfirmacao from "../../components/Modal/ModalConfirmacao/ModalConfirmacao";
import CheckMarkIcon from "../../components/Icon/CheckMarkIcon";
import { orcamentoDefault } from "../../stores/Orcamento.store";
import string from "../../utils/string";
import { withRouter } from "react-router";

const GerenciadorOrcamentos = observer(
  ({
    classes,
    orcamentoStore,
    configuracaoImpressaoStore,
    extratoStore,
    unidadeStore,
    history,
    odontogramaStore,
  }) => {
    const [notification, setNotification] = useState(notificationDefault);
    const [filters, setFilters] = useState(filtersDefault);
    const [orcamentos, setOrcamentos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [lastScroll, setLastScroll] = useState(false);
    const [pageableDTO, setPageableDTO] = useState({
      pageNumber: 0,
      pageSize: 30,
      sortDir: "DESC",
      sortField: "numero",
    });
    const [openModal, setOpenModal] = useState(false);
    const [isPrintMustache, setIsPrintMustache] = useState(false);
    const [isLoadingPrint, setIsLoadingPrint] = useState(false);
    const [orcamentoComparar, setOrcamentoComparar] = useState(null);
    const [orcamentosPrint, setOrcamentosPrint] = useState([]);
    const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
    const [valorTotalPrint, setValorTotalPrint] = useState(0);

    const {
      statusOrcamentoOdontologico,
      numero,
      dataHoraLancamentoInicio,
      dataHoraLancamentoFim,
      dataAgendamentoInicio,
      dataAgendamentoFim,
      sujeitoAtencao,
      tipo,
      profissionalSolicitante,
      status,
      orcamentista,
      faturado,
      profissionalExecutante,
    } = filters;

    useEffect(() => {
      initializeFilters();
      loadOrcamentos({ isClear: true });
    }, []);

    const initializeFilters = async () => {
      try {
        const statusPadrao =
          (await getStatusOrcamentoPendenteAprovacao()) || {};
        setFilters((prevFilters) => ({
          ...prevFilters,
          statusOrcamentoOdontologico: statusPadrao,
        }));
      } catch (error) {
        console.error("Erro ao carregar status padrão:", error);
      }
    };

    const openNotification = (message, variant) => {
      setNotification({
        isOpen: true,
        message,
        variant,
      });

      const timeoutId = setTimeout(() => {
        closeAlertMessage();
        clearTimeout(timeoutId);
      }, 4000);
    };

    const closeAlertMessage = () => {
      const notification = {
        isOpen: false,
        message: "",
        variant: "",
      };
      setNotification(notification);
    };

    const loadOrcamentos = async (options) => {
      try {
        if (loading) return;

        setLoading(true);
        const statusOrcamentoOdontologicoNormalized = Array.isArray(
          statusOrcamentoOdontologico
        )
          ? statusOrcamentoOdontologico[0]
          : statusOrcamentoOdontologico;

        const dataHoraLancamentoInicioMoment = dataHoraLancamentoInicio
          ? moment(dataHoraLancamentoInicio).format("YYYY-MM-DDT00:00:00")
          : null;
        const dataHoraLancamentoFimMoment = dataHoraLancamentoFim
          ? moment(dataHoraLancamentoFim).format("YYYY-MM-DDT23:59:59")
          : null;
        const dataAgendamentoInicioMoment = dataAgendamentoInicio
          ? moment(dataAgendamentoInicio).format("YYYY-MM-DD")
          : null;
        const dataAgendamentoFimMoment = dataAgendamentoFim
          ? moment(dataAgendamentoFim).format("YYYY-MM-DD")
          : null;
        const variables = {
          ...(sujeitoAtencao?.id && { sujeitoAtencaoId: sujeitoAtencao.id }),
          ...(statusOrcamentoOdontologicoNormalized?.id &&
            tipo?.value === "ODONTOLOGICO" && {
              statusOrcamentoOdontologicoId:
                statusOrcamentoOdontologicoNormalized.id,
            }),
          ...(status?.value && tipo?.value === "PROCEDIMENTO" && { status: status.value }),
          ...(numero && { numero: Number(numero) }),
          ...getTipoFiltroDeData(dataHoraLancamentoInicioMoment,dataHoraLancamentoFimMoment),
          ...(dataAgendamentoInicio && {
            dataAgendamentoInicio: dataAgendamentoInicioMoment,
          }),
          ...(dataAgendamentoFim && {
            dataAgendamentoFim: dataAgendamentoFimMoment,
          }),
          pageableDTO: {
            ...pageableDTO,
            pageNumber: options?.isClear ? 0 : pageableDTO.pageNumber,
          },
          tipos: tipo ? [tipo.value] : ["ODONTOLOGICO", "PROCEDIMENTO"],
          ...(profissionalSolicitante?.id && {
            profissionalSolicitanteId: profissionalSolicitante.id,
          }),
          ...(orcamentista?.id && {
            orcamentistaId: orcamentista.id,
          }),
          ...(faturado?.value !== undefined && {
            faturado: faturado.value,
          }),
          ...(profissionalExecutante?.id && {
            executanteId: profissionalExecutante.id,
          }),
        };

        const response = await findAllOrcamentoOdontologicoProcedimento(
          variables
        );
        const { last, content } = response;

        setOrcamentos(options?.isClear ? content : [...orcamentos, ...content]);
        setLastScroll(last);
        setPageableDTO({
          ...pageableDTO,
          pageNumber: options?.isClear ? 1 : pageableDTO.pageNumber + 1,
        });
      } catch (error) {
        openNotification("Erro ao carregar os orçamentos", "error");
      } finally {
        setLoading(false);
      }
    };

    const getTipoFiltroDeData = (dataInicio, dataFim)=>{
      if(filters.tipoFiltro?.value === "EMISSAO"){
        return {
          dataHoraLancamentoInicio: dataInicio,
          dataHoraLancamentoFim: dataFim,
        }
      }else{
        return {
          dataFaturamentoInicio: moment(dataInicio).format("YYYY-MM-DD"),
          dataFaturamentoFim: moment(dataFim).format("YYYY-MM-DD"),
        }
      }
    }

    const handleSelectOrcamento = async (orcamentoId) => {
      const orcamento = await orcamentoStore.getDadosOrcamentoGerenciador(
        orcamentoId
      );
      setOrcamentoComparar(orcamento);

      setOpenModal(true);
    };

    const handleDownload = async () => {
      const dataHoraLancamentoInicioMoment = dataHoraLancamentoInicio
        ? moment(dataHoraLancamentoInicio).format("YYYY-MM-DDT00:00:00")
        : null;
      const dataHoraLancamentoFimMoment = dataHoraLancamentoFim
        ? moment(dataHoraLancamentoFim).format("YYYY-MM-DDT23:59:59")
        : null;
      const dataAgendamentoInicioMoment = dataAgendamentoInicio
        ? moment(dataAgendamentoInicio).format("YYYY-MM-DD")
        : null;
      const dataAgendamentoFimMoment = dataAgendamentoFim
        ? moment(dataAgendamentoFim).format("YYYY-MM-DD")
        : null;

      const statusOrcamentoOdontologicoNormalized = Array.isArray(
        statusOrcamentoOdontologico
      )
        ? statusOrcamentoOdontologico[0]
        : statusOrcamentoOdontologico;

      const variables = {
        ...(sujeitoAtencao?.id && { sujeitoAtencaoId: sujeitoAtencao.id }),
        ...(statusOrcamentoOdontologicoNormalized?.id &&
          tipo?.value === "ODONTOLOGICO" && {
            statusOrcamentoOdontologicoId:
              statusOrcamentoOdontologicoNormalized.id,
          }),
          ...(status?.value && tipo?.value === "PROCEDIMENTO" && { status: status.value }),
        ...(numero && { numero: Number(numero) }),
       ...getTipoFiltroDeData(dataHoraLancamentoInicioMoment,dataHoraLancamentoFimMoment),
        ...(dataAgendamentoInicio && {
          dataAgendamentoInicio: dataAgendamentoInicioMoment,
        }),
        ...(dataAgendamentoFim && {
          dataAgendamentoFim: dataAgendamentoFimMoment,
        }),
        ...(profissionalSolicitante?.id && {
          profissionalSolicitanteId: profissionalSolicitante.id,
        }),
        tipos: tipo ? [tipo.value] : ["ODONTOLOGICO", "PROCEDIMENTO"],
        ...(orcamentista?.id && {
          orcamentistaId: orcamentista.id,
        }),
        ...(faturado?.value !== undefined && {
          faturado: faturado.value,
        }),
        ...(profissionalExecutante?.id && {
          executanteId: profissionalExecutante.id,
        }),
      };

      const base64 = await relatorioAllOrcamentoCsv(variables);
      if (base64 === "error") return;
      const blob = base64Convert(base64);
      const url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "relatorioOrcamentos.csv");
      document.body.appendChild(link);
      link.click();
    };

    const handlePrint = async () => {
      try {
        setIsLoadingPrint(true);
        await configuracaoImpressaoStore.getConfig("RELATORIO");

        const statusOrcamentoOdontologicoNormalized = Array.isArray(
          statusOrcamentoOdontologico
        )
          ? statusOrcamentoOdontologico[0]
          : statusOrcamentoOdontologico;

        const dataHoraLancamentoInicioMoment = moment(
          dataHoraLancamentoInicio
        ).format("YYYY-MM-DDTHH:mm:ss");
        const dataHoraLancamentoFimMoment = dataHoraLancamentoFim
          ? moment(dataHoraLancamentoFim).format("YYYY-MM-DDT23:59:59")
          : null;
        const dataAgendamentoInicioMoment = dataAgendamentoInicio
          ? moment(dataAgendamentoInicio).format("YYYY-MM-DD")
          : null;
        const dataAgendamentoFimMoment = dataAgendamentoFim
          ? moment(dataAgendamentoFim).format("YYYY-MM-DD")
          : null;

        const variables = {
          ...(sujeitoAtencao?.id && { sujeitoAtencaoId: sujeitoAtencao.id }),
          ...(statusOrcamentoOdontologicoNormalized?.id &&
            tipo?.value === "ODONTOLOGICO" && {
              statusOrcamentoOdontologicoId:
                statusOrcamentoOdontologicoNormalized.id,
            }),
          ...(status?.value && tipo?.value === "PROCEDIMENTO" && { status: status.value }),
          ...(numero && { numero: Number(numero) }),
           ...getTipoFiltroDeData(dataHoraLancamentoInicioMoment,dataHoraLancamentoFimMoment),
          ...(dataAgendamentoInicioMoment && {
            dataAgendamentoInicio: dataAgendamentoInicioMoment,
          }),
          ...(dataAgendamentoFimMoment && {
            dataAgendamentoFim: dataAgendamentoFimMoment,
          }),
          ...(profissionalSolicitante?.id && {
            profissionalSolicitanteId: profissionalSolicitante.id,
          }),
          tipos: tipo ? [tipo.value] : ["ODONTOLOGICO", "PROCEDIMENTO"],
          ...(orcamentista?.id && {
            orcamentistaId: orcamentista.id,
          }),
          ...(faturado?.value !== undefined && {
            faturado: faturado.value,
          }),
          ...(profissionalExecutante?.id && {
            executanteId: profissionalExecutante.id,
          }),
        };

        const [response, valorTotal] = await Promise.all([
          findAllOrcamentoList(variables),
          calcularValorTotalFindAllOrcamento(variables)
        ]);

        setOrcamentosPrint(response);
        setValorTotalPrint(valorTotal || 0);

        setIsPrintMustache(true);
      } catch (error) {
        openNotification("Erro ao imprimir o relatório de orçamentos", "error");
      } finally {
        setIsLoadingPrint(false);
      }
    };

    const handleCloseModalConfirmacao = () => {
      orcamentoStore.orcamento = orcamentoDefault;
      odontogramaStore.dadosModalConfirmacao.open = false;
      setOpenModalConfirmacao(false);
    };

    const handleClickFaturar = async () => {
      try {
        await unidadeStore.inicializaConfiguracaoUnidade();
        const orcamentoId = orcamentoStore.orcamento.id;

        const { configuracaoUnidade } = unidadeStore;
        const { azulControleAtivado, utilizaFinanceiroAppHealth } =
          configuracaoUnidade || {};

        const showFinanceiroAzulControle =
          azulControleAtivado && !utilizaFinanceiroAppHealth;

        showFinanceiroAzulControle
          ? await orcamentoStore.handleFaturarFinanceiroCompleto(orcamentoId)
          : await handleFaturarFinanceiroSimples(orcamentoId);

        handleCloseModalConfirmacao();

        return closePopper;
      } catch (e) {
        console.error(e);
      }
    };

    const handleFaturarFinanceiroSimples = async () => {
      try {
        const {
          profissionalSaude,
          valor,
          desconto,
          tipoDesconto,
          orcamentoProcedimentos,
          sujeitoAtencao,
        } = orcamentoStore.orcamento || {};

        const orcamento = {
          ...orcamentoStore.orcamento,
          subtotal: string.calculaDesconto(valor, desconto, tipoDesconto),
        };

        const procedimentos = orcamentoProcedimentos
          .filter((item) => item.checked)
          .map((item) => {
            const procedimento = item.procedimentoOdontologico?.procedimento;

            return procedimento;
          });

        extratoStore.preencherDadosOrcamentoOdontologico({
          tipo: "RECEITA",
          sujeitoAtencao: sujeitoAtencao,
          ...(profissionalSaude?.id && {
            profissionalSaude: {
              ...profissionalSaude,
              label: profissionalSaude.nome,
              value: profissionalSaude.id,
            },
          }),
          procedimentos,
          orcamento: orcamento,
        });
        history.push("/financeiro");
        setOpenModalConfirmacao(false);
      } catch (error) {
        console.log(error);
      }
    };

    return (
      <div className={classes.container}>
        <PageTitle title="Gerenciador de Orçamentos" />
        <HeaderFilters
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          loadOrcamentos={loadOrcamentos}
          getTipoFiltroDeData={getTipoFiltroDeData}
        />
        <div className={classes.content}>
          <GerenciadorOrcamentosTable
            orcamentos={orcamentos}
            lastScroll={lastScroll}
            loadOrcamentos={loadOrcamentos}
            handleSelectOrcamento={handleSelectOrcamento}
            loading={loading}
          />
        </div>
        {openModal && (
          <ModalOrcamentoGerenciador
            openModalOrcamento={openModal}
            setOpenModalOrcamento={setOpenModal}
            loadList={() => loadOrcamentos({ isClear: true })}
            sujeitoAtencaoSelected={orcamentoStore.orcamento.sujeitoAtencao}
            statusBack={orcamentoComparar.statusOrcamentoOdontologico}
            orcamentoComparar={orcamentoComparar}
            setOpenModalConfirmacao={setOpenModalConfirmacao}
          />
        )}
        <div className={classes.containerButtons}>
          <Button
            id="gro-gro-btn-imp"
            bgColor="#FBBF6D"
            onClick={handlePrint}
            shape="circle"
            disabled={isLoadingPrint}
          >
            <PrintIcon />
          </Button>
          <Button
            id="gro-gro-btn-dwn"
            bgColor="#FBBF6D"
            onClick={handleDownload}
            shape="circle"
            disabled={isLoadingPrint}
          >
            <DownaloadIcon />
          </Button>
        </div>
        {openModalConfirmacao && (
          <ModalConfirmacao
            open={openModalConfirmacao}
            icon={<CheckMarkIcon />}
            onClose={() => handleCloseModalConfirmacao()}
            color={"green"}
            title={"Orçamento aprovado! Deseja faturar?"}
            buttons={{
              labelPrimaryButton: "Fatura depois",
              labelSecondButton: "Faturar agora",
              colorCustomPrimaryButton: "transparency",
              colorCustomSecondButton: "green",
              handlePrimaryButton: () => handleCloseModalConfirmacao(),
              handleSecondButton: () => handleClickFaturar(),
              idPrimaryButton: "gro-gro-btn-fdp",
              idSecondButton: "gro-gro-btn-fag",
            }}
          />
        )}
        {isPrintMustache && (
          <ImpressaoHtml
            isPrintMustache={isPrintMustache}
            handlePrintMustache={() => setIsPrintMustache(false)}
            htmlStringComponent={
              <GerenciadorOrcamentosRelatorio
                dadosRelatorio={orcamentosPrint || []}
                filters={filters}
                valorTotal={valorTotalPrint}
              />
            }
          />
        )}
        <Notification
          close={() => closeAlertMessage()}
          isOpen={notification.isOpen}
          variant={notification.variant}
          message={notification.message}
        />
        <Footer />
      </div>
    );
  }
);

const styles = {
  container: {
    background: "#f2f2f2",
    width: 'calc(100% - 72px)',
  },
  content: {
    height: "calc(100% - 205px)",
    margin: "24px 24px 0 24px",
    borderRadius: "16px",
    background: "#fff",
    overflowY: "auto",
    "& > div": {
      height: "100%",
    }
  },
  containerButtons: {
    display: "flex",
    gap: "8px",
    position: "absolute",
    right: "37px",
    bottom: "88px",
  },
};

const GerenciadorOrcamentosWithStyles = withRouter(
  withStyles(styles)(GerenciadorOrcamentos)
);
export default inject(
  "orcamentoStore",
  "configuracaoImpressaoStore",
  "extratoStore",
  "unidadeStore",
  "odontogramaStore"
)(GerenciadorOrcamentosWithStyles);
